import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  text-align: left;\n  font-weight: 400;\n  color: ",
        ";\n\n  border-bottom: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Link, Portal } from "@miro-site/core";
import Popup from "./../../popup/Popup";
import { Transition } from "react-transition-group";
import Accordion from "./../../accordion/Accordion";
import Item from "./../../accordion/Item";
import useFullscreenModal from "../../../hooks/useFullscreenModal";
var transitionStyles = {
    entering: {
        opacity: 1,
        visibility: "visible"
    },
    entered: {
        opacity: 1,
        visibility: "visible"
    },
    exiting: {
        opacity: 0,
        visibility: "hidden"
    },
    exited: {
        opacity: 0,
        visibility: "hidden"
    }
};
var CategoryNavMobile = /*#__PURE__*/ React.forwardRef(function(param, ref) {
    var rootGroups = param.rootGroups, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, onMobilePopupClose = param.onMobilePopupClose, onCategoryOpen = param.onCategoryOpen;
    useFullscreenModal(isVisible);
    return /*#__PURE__*/ _jsx(Transition, {
        in: isVisible,
        timeout: 2500,
        children: function(state) {
            return /*#__PURE__*/ _jsx(Portal, {
                children: /*#__PURE__*/ _jsx(Popup, {
                    $styles: _object_spread({
                        position: "fixed",
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0,
                        height: "100%",
                        overflow: "auto",
                        zIndex: 710,
                        textAlign: "center",
                        transition: "opacity 250ms ease-in-out, visibility 250ms ease-in-out",
                        visibility: "hidden",
                        opacity: 0
                    }, transitionStyles[state]),
                    onCloseClick: function() {
                        if (onMobilePopupClose) {
                            onMobilePopupClose();
                        }
                    },
                    children: /*#__PURE__*/ _jsx(Accordion, {
                        children: rootGroups.map(function(group, index) {
                            return /*#__PURE__*/ _jsx(Item, {
                                header: group.title,
                                children: group.categories.map(function(category) {
                                    return /*#__PURE__*/ _jsx(CategoryLink, {
                                        onClick: function(e) {
                                            if (onCategoryOpen) {
                                                e.preventDefault();
                                                onCategoryOpen(category);
                                            }
                                        },
                                        href: category.href,
                                        children: category.title
                                    }, category.title);
                                })
                            }, index);
                        })
                    })
                })
            });
        }
    });
});
CategoryNavMobile.displayName = "CategoryNavMobile";
var CategoryLink = styled(Link).attrs({
    $size: "default",
    $styles: {
        marginLeft: [
            20,
            null,
            null,
            null
        ],
        paddingBottom: [
            30,
            null,
            null,
            null
        ]
    }
}).withConfig({
    componentId: "sc-d5e44a06-0"
})(_templateObject(), function(props) {
    return props.theme.templates.colors.secondary60;
});
export default CategoryNavMobile;
